// Additional Libraries
import { sliders } from '../modules/sliders';
import { setup_acf_map } from '../modules/map';

export default {
	init() {
		// JavaScript to be fired on all pages
		setup_scrolling();
		//back_to_top();
		setup_overlay_trigger();
		//rellax();
		setup_site_loader();
		sliders();
		setup_acf_map();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};

function setup_scrolling()
{
	$(window).on('scroll', function() {
		//Add the 'scrolled' class
		let scroll = $(this).scrollTop();
		let body = $('body');
		if(scroll > 0)
		{
			body.addClass('scrolled');
		}
		else
		{
			body.removeClass('scrolled');
		}

		//Add a class when scrolling past 100vh
		let landing = $('.REFERENCE_DIV_HERE');
		if(scroll >= landing.height())
		{
			body.addClass('fold');
		}
		else
		{
			body.removeClass('fold');
		}

	});
}

/*
function back_to_top()
{
	$('.back-to-top').click(function (e){
		e.preventDefault();
		$('html,body').animate({
			scrollTop: 0,
		}, 'slow');
	});
}
*/

function setup_overlay_trigger()
{
	$('.overlay-trigger').click(function (e){
		e.preventDefault();
		let body = $('body');
		if(body.hasClass('overlay-active'))
		{
			body.removeClass('overlay-active');
		}
		else
		{
			body.addClass('overlay-active');
		}
	});

	$('.project-overlay').click(function(e){
		if(e.target != this)
		{
			//Not the actual object
			return;
		}
		$('.overlay-trigger').first().click();
	})

	$('.project-overlay .inner-wrapper').click(function(e){
		if(e.target != this)
		{
			//Not the actual object
			return;
		}
		$('.overlay-trigger').first().click();
	})
}

/*
function rellax()
{
	var rellax = new Rellax('.rellax', {
		center: false,
	});
}
*/

function setup_site_loader()
{
	let loader = $('.site-loader');
	if(loader.length > 0)
	{
		setTimeout(function(){
			let loader = $('.site-loader');
			loader.removeClass('active');
		}, 1500);
	}
}




// WEBPACK FOOTER //
// ./scripts/routes/common.js